
import { defineComponent } from 'vue'
import { encodeRoute } from '~/utils/router'

export default defineComponent({
  name: 'FourOFour',
  data() {
    return {
      loginUrl: ''
    }
  },
  created() {
    this.setLoginUrl()
  },
  methods: {
    setLoginUrl() {
      if (!this.$route.name?.startsWith('provider-owner')) {
        this.loginUrl = '/login'
      } else {
        let next = ''
        try {
          next = encodeRoute(this.$route)
        } catch (error) {
          this.$logErrorAndToast(error as Error)
        }
        this.loginUrl = `/login?next=${next}`
      }
    }
  }
})
